import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import TermsOfService from './TermsOfService';
import PrivacyPolicy from './PrivacyPolicy';

const LegalModal = ({ isOpen, onClose, initialTab = 'terms' }) => {
  const [activeTab, setActiveTab] = useState(initialTab);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (isOpen && initialTab) {
      setActiveTab(initialTab);
    }
  }, [initialTab, isOpen]);

  if (!isOpen || !mounted) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleTabSwitch = (tab) => {
    setActiveTab(tab);
  };

  const content = (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        background: 'rgba(6, 6, 14, 0.75)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)'
      }}
      onClick={handleBackdropClick}
    >
      <div
        style={{
          width: 'min(90vw, 800px)',
          maxHeight: '85vh',
          background: 'linear-gradient(135deg, #1e3a8a 0%, #3730a3 50%, #1e3a8a 100%)',
          borderRadius: '16px',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
          border: '1px solid rgba(99, 102, 241, 0.3)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* 头部区域 */}
        <div style={{ flexShrink: 0 }}>
          {/* 关闭按钮行 */}
          <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px 14px 4px' }}>
            <button
              onClick={onClose}
              title="关闭"
              style={{
                background: 'rgba(255,255,255,0.08)',
                border: '1px solid rgba(255,255,255,0.12)',
                color: '#9ca3af',
                cursor: 'pointer',
                padding: '6px 12px',
                borderRadius: '8px',
                fontSize: '14px',
                transition: 'all 0.15s'
              }}
            >
              ✕ 关闭
            </button>
          </div>

          {/* Tab 切换栏 */}
          <div
            style={{
              display: 'flex',
              borderBottom: '1px solid rgba(99, 102, 241, 0.3)'
            }}
          >
            <button
              type="button"
              onClick={() => handleTabSwitch('terms')}
              style={{
                flex: 1,
                textAlign: 'center',
                padding: '14px 16px',
                background: activeTab === 'terms' ? 'rgba(99,102,241,0.25)' : 'transparent',
                border: 'none',
                borderBottom: activeTab === 'terms' ? '2px solid #818cf8' : '2px solid transparent',
                color: activeTab === 'terms' ? '#ffffff' : '#c7d2fe',
                fontWeight: activeTab === 'terms' ? '600' : '400',
                fontSize: '15px',
                cursor: 'pointer',
                outline: 'none',
                transition: 'all 0.2s'
              }}
            >
              服务条款
            </button>

            <div style={{ width: '1px', backgroundColor: 'rgba(99,102,241,0.2)', margin: '10px 0' }} />

            <button
              type="button"
              onClick={() => handleTabSwitch('privacy')}
              style={{
                flex: 1,
                textAlign: 'center',
                padding: '14px 16px',
                background: activeTab === 'privacy' ? 'rgba(99,102,241,0.25)' : 'transparent',
                border: 'none',
                borderBottom: activeTab === 'privacy' ? '2px solid #818cf8' : '2px solid transparent',
                color: activeTab === 'privacy' ? '#ffffff' : '#c7d2fe',
                fontWeight: activeTab === 'privacy' ? '600' : '400',
                fontSize: '15px',
                cursor: 'pointer',
                outline: 'none',
                transition: 'all 0.2s'
              }}
            >
              隐私政策
            </button>
          </div>
        </div>

        {/* 内容区 */}
        <div style={{ 
          flex: 1, 
          overflowY: 'auto', 
          padding: '20px 24px', 
          color: '#e0e7ff', 
          lineHeight: 1.7 
        }}>
          {activeTab === 'terms' ? <TermsOfService /> : <PrivacyPolicy />}
        </div>
      </div>
    </div>
  );

  // 使用 Portal 渲染到 body，彻底脱离 AuthModal 的 DOM 层级
  return ReactDOM.createPortal(content, document.body);
};

export default LegalModal;
